import { Col, Row } from "antd";
import React from "react";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";

const IncompleteTransfersRightBar = [
    RightBarMethod(
        " REPORTS",
        "t1",
        <i className="fa-solid fa-chart-column"></i>,
        [
          RightBarMethod("Bank Account Activity", "1", "", "", "/"),
          RightBarMethod("General Ledger", "2", "", "", "/"),
        ]
      ),
  ];

function Incomplete() {
  return (
    <>
      <div>
        <PageHeading heading="Incomplete Transfers" />
        <Row justify="center">
          <Col>There are no incomplete bank transfers to display.</Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={IncompleteTransfersRightBar} />
      </div>
    </>
  );
}

export default Incomplete;